import styled, { css } from 'styled-components'

const Form = styled.form`
	width: 100%;
`

const Label = styled.label.attrs((props) => ({
	htmlFor: props.htmlFor
}))`
	font-weight: ${(props) => (props.checked ? 'bold' : 'normal')};
	color: ${(props) => (props.checked ? '#44344F' : '#7c7184')};
	font-size: 12px;
	white-space: nowrap;

	${({ checked }) =>
		checked &&
		css`
			font-weight: bold;
			color: #44344f;
		`}
`

const Error = styled.p`
	margin: 0;
	font-weight: normal;
	color: red;
	opacity: 0;
	transition: 0.2s ease-out;
	font-size: 12px;
	text-align: left;
	padding-top: 2px;
	padding-left: 18px;
	white-space: pre-wrap;

	${({ show }) =>
		show &&
		css`
			opacity: 1;
		`}
`

export { Form, Label, Error }
